import { ReactNode } from "react";

import Box from "../Box";
import { ButtonProps } from "../Button";
import { SplitControlContext } from "./context";
import styles from "./styles.module.css";

type SplitControlWrapperProps = {
  children: ReactNode;
} & Pick<ButtonProps, "variant" | "size">;

const SplitControlWrapper = ({ children, ...restProps }: SplitControlWrapperProps) => {
  return (
    <SplitControlContext.Provider value={restProps}>
      <Box className={styles.splitControlWrapper}>{children}</Box>
    </SplitControlContext.Provider>
  );
};

SplitControlWrapper.displayName = "DS.SplitControl.Wrapper";

export default SplitControlWrapper;
